module.exports = __webpack_public_path__ + "img/slider4.a9b53e84.png";